var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconBinance = function SvgIconBinance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 .964 2.973 3.045-7.487 7.486-2.973-2.973L12 .964ZM16.513 5.477l2.973 3.045-12 12-2.973-2.973 12-12.072ZM2.973 9.99l2.973 3.046-2.973 2.973L0 13.036 2.973 9.99ZM21.027 9.99 24 13.037l-12 12-2.973-2.974 12-12.071Z",
    fill: "#FFC700"
  })));
};

export default SvgIconBinance;